module.exports = " <label class=v-toggle :class=\"{'v-toggle--checked': checked}\"> <input type=checkbox v-model=checked :name=name> <span class=v-toggle_handle></span> </label> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/Common/Toggle.vue
// module id = 639
// module chunks = 0